import type { Phrases, TranslationExclusionValue } from '../../types';
import { checkExcludedNode } from '../utils/check-excluded-node';
import { getAllShadowRoots } from '../utils/get-all-shadow-roots';

type FoundElements = {
  nodes: Element[];
  phrases: Phrases;
};

type ElementsFinderParams = {
  element: Node | Element;
  querySelector: string;
  attributeName: string;
  translationExclusions?: TranslationExclusionValue[];
};

export function elementsFinder({
  element,
  querySelector,
  attributeName,
  translationExclusions
}: ElementsFinderParams): FoundElements {
  const nodes: Element[] = [];
  const phrases: Phrases = [];

  if (!(element instanceof Element)) {
    return { nodes, phrases };
  }

  const collectTranslatableElements = (context: Element | ShadowRoot) => {
    const elements = context.querySelectorAll(querySelector);

    elements.forEach((element) => {
      const value = element.getAttribute(attributeName);

      if (!value || checkExcludedNode(element, translationExclusions)) {
        return;
      }

      nodes.push(element);
      phrases.push(value);
    });
  };

  collectTranslatableElements(element);

  const shadowRoots = getAllShadowRoots(element);

  shadowRoots.forEach(collectTranslatableElements);

  return { nodes, phrases };
}
